import client from '../client';

export const login = async (body: {
  email: string;
  password: string;
}) => client.post('/admin/user/auth/log-in', body);
